/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefit_RankingInputs */

const en_directory_promotion_benefit_ranking = /** @type {(inputs: Directory_Promotion_Benefit_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment never changes organic ranking or editorial review decisions.`)
};

const zh_directory_promotion_benefit_ranking = /** @type {(inputs: Directory_Promotion_Benefit_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费不会改变自然排名，也不会影响编辑审核决定。`)
};

/**
* | output |
* | --- |
* | "Payment never changes organic ranking or editorial review decisions." |
*
* @param {Directory_Promotion_Benefit_RankingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefit_ranking = /** @type {((inputs?: Directory_Promotion_Benefit_RankingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefit_RankingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefit_ranking(inputs)
	return zh_directory_promotion_benefit_ranking(inputs)
});
export { directory_promotion_benefit_ranking as "directory.promotion.benefit_ranking" }